import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu, MenuItem } from '@mui/material'
import { useSelector } from 'react-redux'

const ContextMenuContent = ({ state, handleClose, completed }) => {
  const permissions = useSelector((state) => state?.session?.permissions?.['marking-class'] || {})
  const marking = useSelector((state) => state?.assessment?.currentCurriculum?.marking || [])
  const minMarking = marking?.find((item) => item.minValue) || {}

  const options = []
  if (marking.length === 0) return <></>

  if (
    state?.item?.completed &&
    String(state?.item?.completed) !== String(minMarking._id) &&
    permissions['by-teacher'] &&
    completed === 'completedTeacher'
  ) {
    options.push({ divider: true })
    options.push({
      id: 'note',
      label: `Note`,
      icon: ['fas', 'comment-alt-check']
    })
  }

  return (
    <>
      <Menu
        keepMounted
        open={state.mouseY !== null}
        onClose={handleClose}
        anchorReference='anchorPosition'
        anchorPosition={
          state.mouseY !== null && state.mouseX !== null
            ? { top: state.mouseY, left: state.mouseX }
            : undefined
        }
      >
        {marking.map((item) => (
          <MenuItem
            key={`context-menu-marking-${item._id}`}
            onClick={(e) => handleClose(e, { ...item, type: 'marking' })}
            className='text-xs flex gap-1 items-center rounded'
          >
            <FontAwesomeIcon icon='square' className='text-lg' style={{ color: item.primaryColor }} />
            <span style={{ color: item.secondaryColor }} className='text-sm'>
              {item.name}
            </span>
          </MenuItem>
        ))}
        {options.map((item, index) =>
          item.divider ? (
            <hr key={`context-menu-marking-divider-${index}`} className='my-1' />
          ) : (
            <MenuItem
              key={`context-menu-marking-${index}`}
              onClick={(e) => handleClose(e, { type: item.id })}
              className='text-xs flex gap-1 items-center rounded'
            >
              <FontAwesomeIcon icon={item.icon} className='text-lg' />
              <span className='text-sm'>{item.label}</span>
            </MenuItem>
          )
        )}
      </Menu>
    </>
  )
}

export default ContextMenuContent
